import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export const Button = ({
  children,
  className = '',
  ...props
}: ButtonProps) => {
  return <button className={`relative overflow-hidden group bg-gradient-to-r from-gold-antique via-gold-dark to-gold-antique text-parchment font-bold py-4 px-8 rounded-sm transition-all duration-300 hover:shadow-[0_0_30px_rgba(184,146,46,0.35)] hover:scale-105 ${className}`} {...props} data-id="element-13">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-14">
        {children}
      </span>
      <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-15"></div>
    </button>;
};